export const isEmpty = v => v === null || v === undefined || v === "";

export const isString = v => typeof v === "string";

export const doIfNotEmpty = (v, f) => (!isEmpty(v) ? f(v) : v);

export const doIfString = (v, f) => (isString(v) ? f(v) : v);
